import { URLQueries } from '../global_env/url_query'
import { MASErrorTrackPersonalIdsError } from '../mas_error_track'
/**
 * 检测id
 * @param {*} ids 多个id以逗号分隔
 * @returns
 */
export const checkIds = ids => /^\d+(,\d+)*$/.test(ids)
/**
 * 获取query中的ids
 * @param {} keys
 * @returns
 */
export function getQueryIdsByKeys(queryKeys, { needMonitor }) {
  if (!queryKeys?.length) return ''
  let ids = ''
  queryKeys.forEach(key => {
    const queryIds = URLQueries.getQuery(key)?.trim?.()
    if (!queryIds) {
      return
    }
    // 检验ids是否合法
    if (!checkIds(queryIds)) {
      // 增加监控
      needMonitor &&
        MASErrorTrackPersonalIdsError(`${queryKeys}格式错误`, { ids: queryIds })
      return
    }
    ids += `${ids ? ',' : ''}${queryIds}`
  })
  return [...new Set(ids.split(','))].join(',')
}
